import React, { useEffect, useState,useRef} from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Modal,
  Button,
  Dropdown,
  Alert,
  Spinner,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import { useHistory } from "react-router-dom";
function BlockedRider() {
  const history=useHistory()
  const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 5;
  const activePag = useRef(0);
  const [searchData, setSearchData] = useState([]);
  const [show, setShow] = useState(false);
  const [spinner, setSpinner] = useState(true);
  const [id, setId] = useState("");
  const handleClose = () => setShow(false);
  const [blockriders, setallblockriders] = useState([]);
  const chackbox = document.querySelectorAll(".bs_exam_topper input");
  const motherChackBox = document.querySelector(".bs_exam_topper_all input");
  const handleShow = (id) => {
    setId(id);
    setShow(true);
  };
  function getData() {
    axios
      .get(Baseurl.baseurl + "/rider/get-blocked-riders")
      .then((response) => {
        setSpinner(false);
        setallblockriders(response.data.rider);
        setSearchData(response.data.rider);
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };
  useEffect(() => {
    getData();
  }, []);
  const click = () => {
    alert();
  };
  const chackboxFun = (type) => {
    for (let i = 0; i < chackbox.length; i++) {
      const element = chackbox[i];
      if (type === "all") {
        if (motherChackBox.checked) {
          element.checked = true;
        } else {
          element.checked = false;
        }
      } else {
        if (!element.checked) {
          motherChackBox.checked = false;
          break;
        } else {
          motherChackBox.checked = true;
        }
      }
    }
  };
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  const handlesubmit = () => {
    axios
      .put(`${Baseurl.baseurl}/rider/unblock-rider/${id}`)
      .then((response) => {
        if (response.data.status) {
          swal("Unblocked", response.data.message, "success", {
            button: "Done",timer: 1000,
          });
          setallblockriders(response.data.rider);
        } else {
          swal("Oops", response.data.message, "error", { button: "Done",timer: 1000, });
        }

        handleClose();
        getData();
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  };
  function searchRider(value) {
    let filteredData = [];
    if(searchData){
      searchData.map((val) => {
        let phoneString = val.riderPhone.toString();
        if (
          val.riderFirstName.toLowerCase().includes(value) ||
          val.riderLastName.toLowerCase().includes(value) ||
          val.riderEmail.toLowerCase().includes(value) ||
          phoneString.includes(value)
        ) {
          filteredData.push(val);
        }
      });
      setallblockriders(filteredData);
    }
    
  }
  return (
    <Col lg={12}>
      <Modal size="" show={show} onHide={handleClose}>
        <Modal.Header closeButton> 
        <Modal.Title>Unblock Rider</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Are you sure you want to unblock the user</h4>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => handlesubmit()}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      <Card style={{
                color: "white",
                background:
                  "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
              }}>
        <Card.Header>
          <Card.Title className="text-white">Blocked Riders</Card.Title>
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
        </Card.Header>
        <Card.Body>
        <div id="job_data" className="dataTables_wrapper ">
          {spinner ? (
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <Table responsive className="text-white">
              <thead>
                <tr>
                  <th>
                    <strong>SLNO.</strong>
                  </th>
                  <th>
                    <strong>RIDER NAME</strong>
                  </th>
                
                  <th>
                    <strong>Phone No.</strong>
                  </th>
                  {/* <th>
                  <strong>Status</strong>
                </th>
                <th>
                  <strong>Tags</strong>
                </th> */}
                  <th>
                    <strong>Vehicle</strong>
                  </th>
                  <th>
                    <strong>Actions</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {blockriders &&
                  blockriders.map((rider, key) => (
                    <tr key={rider.id}>
                      <td>{key + 1}</td>
                      <td>
                      <div className="d-flex align-items-center">
                          <img
                            src={rider.riderProfileImage}
                            className="rounded-lg mr-2"
                            width={40}
                            height={40}
                            alt=""
                          />{" "}
                          <span className="w-space-no">{rider.riderFirstName} {rider.riderLastName}</span>
                        </div>
                      </td>
                     
                      <td>{rider.riderPhone}</td>
                      {/* <td>{rider.status}</td>
                  <td></td> */}
                      <td>{rider.RiderVehicleType.name}</td>
                      <td>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="warning"
                            className="light sharp i-false"
                          >
                            {svg1}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              as={Link}
                              to={`./rider-details/${rider._id}`}
                            >
                              View
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                handleShow(rider._id);
                              }}
                            >
                              unblock
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          )}
         
          {!blockriders && (
            <Alert
              variant="success"
              className="alert-dismissible fade show text-center"
            >
              Zero Blocked riders
            </Alert>
          )}
          <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default BlockedRider;
